import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getSupplierProductDocumentListData } from './mockData'
import type { ISupplierProductDocument } from '~/types/document/models'

export const {
  getDocuments: getSupplierProductDocuments,
  postDocument: postSupplierProductDocument,
  patchDocument: patchSupplierProductDocument,
  deleteDocument: deleteSupplierProductDocument,
  handlers,
} = makeDocumentAPIs<ISupplierProductDocument>({
  apiPathEntityNamePrefix: 'supplierproduct',
  getDocumentListDataFn: getSupplierProductDocumentListData,
})
